module.exports = __webpack_public_path__ + "static/media/DT1.95add024.jpg";